var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradationHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40722 20.7714V17.7047C9.4072 16.9246 10.0431 16.2908 10.831 16.2856H13.7171C14.5087 16.2856 15.1505 16.9209 15.1505 17.7047V20.7809C15.1503 21.4432 15.6843 21.9845 16.353 22H18.2771C20.1951 22 21.75 20.4607 21.75 18.5618V9.83784C21.7398 9.09083 21.3855 8.38935 20.788 7.93303L14.2077 2.6853C13.0549 1.77157 11.4162 1.77157 10.2634 2.6853L3.71203 7.94256C3.11226 8.39702 2.75739 9.09967 2.75 9.84736V18.5618C2.75 20.4607 4.30488 22 6.22291 22H8.14696C8.83235 22 9.38797 21.4499 9.38797 20.7714",
    fill: "url(#paint0_linear_1334_26561)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1334_26561",
    x1: 2.75,
    y1: 8.34409,
    x2: 22.6072,
    y2: 18.8789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAC5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradationHome);
export default __webpack_public_path__ + "static/media/gradationHome.44e28b3d4f9043fec14eea61a17a5454.svg";
export { ForwardRef as ReactComponent };